import './dropdown.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Dropdown = forwardRef((props, ref) => {
  const className = classNames({
    'dropdown-menu': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Dropdown.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DropdownItem = forwardRef((props, ref) => {
  const className = classNames({
    'dropdown-item': true,
    disabled: props.disabled,
    [props.className]: props.className,
  });

  return (
    <a ref={ref} className={className} onClick={props.onClick}>
      {props.children}
    </a>
  );
});

DropdownItem.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
};

Dropdown.Item = DropdownItem;

export default Dropdown;
